let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("fliVL"), load("lxHfr")]).then(() => parcelRequire('cNXTd'));